<template>
  <v-layout>
    <v-dialog v-model="notesDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Edit Notes</v-card-title>
        <v-card-text>
          <v-textarea v-model="editNotes"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="notesDialog = false">No</v-btn>
          <v-btn color="green darken-1" flat :loading="savingNotes" @click="saveNotes">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="startAlert" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Start Job</v-card-title>
        <v-alert
          :value="activeJob.Allocated !== user.id"
          color="warning"
          icon="priority_high"
        >
          This job is not assigned to you <v-btn color="primary" @click="assignJob" :loading="assigning"><v-icon>assignment_ind</v-icon>Assign</v-btn>
        </v-alert>
        <v-alert
          :value="activeJob.jobStarted"
          color="error"
          icon="priority_high"
        >
          This job has been flagged as started!
        </v-alert>
        <v-card-text>Are you sure you wish to start job <strong>{{activeJob.JobNo}}</strong>, any uncomplete jobs will be discarded?</v-card-text>
        <v-card-text v-if="activeJob.Allocated !== user.id">This job will be automatically assigned to you if you choose to continue.</v-card-text>
        <v-subheader>Summary</v-subheader>
        <v-list dark>
          <v-list-tile v-for="(template, i) in templateSummary" :key="i">
            <v-list-tile-title>{{template}}</v-list-tile-title>
          </v-list-tile>
        </v-list>        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="startAlert = false">No</v-btn>
          <v-btn color="green darken-1" flat @click="startJob">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="continueAlert" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Continue Job</v-card-title>
        <v-card-text>Are you sure you wish to continue job <strong>{{activeJob.JobNo}}</strong>, any uncomplete jobs will be discarded?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="continueAlert = false">No</v-btn>
          <v-btn color="green darken-1" flat @click="continueJob">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container>
      <v-layout row wrap mb-3>
        <v-flex v-if="user.unassigned" xs12 sm4 class="text-xs-left pr-2">
          <v-autocomplete label="Filter by Engineer" v-model="selectEngineer" :items="engineerSelect" item-text="text" item-value="value"></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm4 class="text-xs-left pr-2">
          <v-autocomplete label="Filter by Customer" v-model="selectCustomer" :items="customers" item-text="name" item-value="id" no-data-text="No Results - Please type at least 3 characters"
          :search-input.sync="customerFilter" clearable></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm4 class="text-xs-left px-2" v-if="jobVehicles.length > 0">
          <v-autocomplete label="Filter by Vehicle" v-model="selectVehicle" :items="jobVehicles" item-text="reg" item-value="id" clearable></v-autocomplete>
        </v-flex>
          <v-text-field label="Search by Job ID" v-model="jobFilter" clearable></v-text-field>
        </v-flex>
        <v-flex xs6 sm2 class="px-2">
          <v-checkbox v-model="includeCompleted" label="Include Completed" color="primary"/>
        </v-flex>
        <v-flex xs6 sm2 class="px-2">
          <v-btn @click="getJobs()" v-if="listView" color="primary" :loading="loading" round large>Load Jobs</v-btn>
        </v-flex>
        <v-flex xs12 sm2 class="text-xs-right pl-2">
          Layout: 
          <v-btn icon color="primary" :flat="!listView" @click="listView = !listView">
            <v-icon>list</v-icon>
          </v-btn>
          <v-btn icon color="primary" :flat="listView" @click="listView = !listView">
            <v-icon>today</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-show="!listView">
      <v-flex xs1>
        <v-btn icon color="primary" @click="yesterday()">
          <v-icon>chevron_left</v-icon>
        </v-btn>
      </v-flex>
      <v-flex class="text-xs-center" xs10>
        <v-menu
        ref="date"
        v-model="dateMenu"
        :return-value.sync="date"
        lazy
        transition="scale-transition"
        >
          <h2
            slot="activator"
            style="text-align:center;">
            <v-icon left>today</v-icon>
            {{dateFormatted}}
          </h2>
          <v-date-picker v-model="date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="dateMenu = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.date.save(date)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs1 class="text-xs-right">
        <v-btn icon color="primary" @click="tomorrow()">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 class="text-xs-center">
          <v-progress-circular v-if="loading" indeterminate v-bind:size="70" v-bind:width="7" color="primary"></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-alert
        color="error"
        icon="cloud_off"
        :value="!online"
        transition="scale-transition"
      >
        No Connection, using saved data.
      </v-alert>
      <v-alert color="info" :value="!hasCustomers && !loading" icon="info_outline">
        {{listView ? 'You do not have any jobs' : 'You do not have any jobs on this day'}}
      </v-alert>
      <template v-if="hasCustomers && !loading && vehicleFilteredJobs.length > 0">
        <v-list dark v-for="(job, i) in vehicleFilteredJobs" v-bind:key="i" :class="[(job.Status === 2 || outboxItems.indexOf(job.number) !== -1 ? 'green' : inProgressKeys[job.number]  ? 'orange lighten-1' : ''), 'mb-2 pa-2']">
          <v-list-tile three-line>
            <v-list-tile-action>
              <v-btn @click.prevent="openEditNoteDialog(job)" icon><v-icon>mdi-pencil</v-icon></v-btn>
            </v-list-tile-action>
            <v-list-tile-content @click.prevent="activateJob(job)">
              <v-list-tile-title>{{ job.Vehicle ? vehicleRegFromID(job.Vehicle) : job.vehReg }}</v-list-tile-title>
              <v-list-tile-sub-title v-if="job.Date">{{ job.Date | formatDate }}</v-list-tile-sub-title>
              <v-list-tile-sub-title>Job ID: {{job.JobNo}}</v-list-tile-sub-title>
              <v-list-tile-sub-title>Project ID: {{job.Project}}</v-list-tile-sub-title>
              {{job.notes}}
            </v-list-tile-content>
            <v-icon v-if="isCurrentJob(job)">schedule</v-icon>
            <v-icon v-else-if="outboxItems.indexOf(job.number) !== -1">mdi-sync-off</v-icon>
            <v-icon v-else-if="inProgressKeys[job.number]">mdi-progress-clock</v-icon>
          </v-list-tile>
        </v-list>
      </template>
      <template v-if="hasCustomers && !loading && selectCustomer && vehicleFilteredJobs.length === 0">
        <h3 class="text-xs-center">No jobs found for this customer</h3>
      </template>
    </v-container>
    <v-snackbar v-model="snackbar" multi-line color="error">
      {{snackbarText}}
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>

import { firedb, fireStore } from '../firebase'
import dbPromise from '../dbPromise'
import moment from 'moment'

export default {
  data () {
    return {
      online: true,
      assigning: false,
      activeJob: {},
      currentJob: {
        number: 0
      },
      customerFilter: '',
      startAlert: false,
      continueAlert: false,
      jobs: [],
      loading: false,
      templateStore: {},
      oldTemplateStore: {},
      snackbar: false,
      snackbarText: '',
      date: null,
      dateMenu: false,
      listView: true,
      outboxItems: [],
      selectCustomer: null,
      selectVehicle: null,
      inProgressJobs: [],
      inProgressKeys: {},
      selectEngineer: 1,
      includeCompleted: false,
      notesDialog: false,
      editNotes: '',
      noteEditId: null,
      savingNotes: false,
      jobFilter: '',
      templateSummary: []
    }
  },
  created () {
    this.date = moment().format('YYYY-MM-DD')
    // this.getJobs()

    dbPromise().then((db) => {
      let tx = db.transaction('currentJob')
      let currentStore = tx.objectStore('currentJob')
      return (currentStore.get(0))
    }).then((val) => {
      if (val !== undefined) {
        this.currentJob = val
      }
    })

    dbPromise().then((db) => {
      let tx = db.transaction('inProgressJobs')
      let inProgressJobsStore = tx.objectStore('inProgressJobs')
      return (inProgressJobsStore.getAllKeys())
    }).then((keys) => {
      keys.forEach((key) => {
        dbPromise().then((db) => {
          let tx = db.transaction('inProgressJobs')
          let inProgressJobsStore = tx.objectStore('inProgressJobs')
          return (inProgressJobsStore.get(key))
        }).then((val) => {
          if (val) {
            this.inProgressJobs[key] = val
            this.inProgressKeys[val[0].number] = key
          }
        })
      })
    })

    this.outboxItems = []
    dbPromise().then(db => {
      let tx = db.transaction('outbox')
      let outboxStore = tx.objectStore('outbox')
      return (outboxStore.getAllKeys())
    }).then((keys) => {
      if (keys.length > 0) {
        keys.forEach(element => {
          dbPromise().then(db => {
            return db.transaction('outbox').objectStore('outbox').get(element)
          }).then((val) => {
            val.element = element
            this.outboxItems.push(val.number)
          })
        })
      }
    })

    this.resetTemplateObj()
  },
  watch: {
    date () {
      if (!this.listView) {
        this.getJobs()
      }
    },
    listView (val) {
      if (!val) {
        this.getJobs()
      }
    },
    selectCustomer (val) {
      if (val) {
        this.selectVehicle = null
      }
    },
    selectEngineer (val) {
      if (!this.listView) {
        this.getJobs()
      }
    }
  },
  computed: {
    engineerSelect () {
      let options = [
        {
          text: 'Your assigned jobs',
          value: 1
        },
        {
          text: 'Unassigned jobs',
          value: -1
        }
      ]
      if (this.user && this.user.company === '5BepIUcIKKTJbKBzjP9x') {
        options.push({
          text: 'All Engineers Jobs',
          value: -2
        })
      }
      return options
    },
    user () {
      return this.$store.getters.user
    },
    hasCustomers () {
      return this.jobs.length > 0
    },
    dateFormatted () {
      return moment(this.date).format('DD/MM/YYYY')
    },
    filteredJobs () {
      console.log('ger')
      let arr = this.jobs
      if (this.selectCustomer) {
        arr = arr.filter(job => job.Customer === this.selectCustomer)
      }
      return arr
    },
    vehicleFilteredJobs () {
      let arr = this.jobs
      if (this.selectVehicle) {
        arr = arr.filter(job => job.Vehicle === this.selectVehicle)
      }
      if (this.jobFilter) {
        arr = arr.filter(job => job.JobNo.includes(this.jobFilter))
      }
      return arr
    },
    customers () {
      if (this.customerFilter === null || this.customerFilter === undefined || this.customerFilter.length < 3) {
        return []
      }
      return this.$store.getters.customers.sort((a, b) => {
        const aName = a.name.toLowerCase()
        const bName = b.name.toLowerCase()
        return aName < bName ? -1 : aName > bName ? 1 : 0
      })
    },
    vehicles () {
      return this.$store.getters.vehicles
    },
    jobVehicles () {
      let arr = []
      if (this.filteredJobs.length > 0) {
        this.filteredJobs.forEach(job => {
          if (job.Vehicle && this.vehicles) {
            let vehicleIndex = this.vehicles.findIndex(vehicle => {
              return vehicle.id === job.Vehicle
            })
            if (vehicleIndex > -1 && this.vehicles[vehicleIndex]['VehicleReg']) {
              arr.push({reg: this.vehicles[vehicleIndex]['VehicleReg'], id: job.Vehicle})
            }
          }
        })
      }
      return arr
    }
  },
  filters: {
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  },
  methods: {
    saveNotes () {
      this.savingNotes = true
      fireStore.collection('Jobs').doc(this.noteEditId).update({notes: this.editNotes})
      .then(() => {
        this.getJobs()
        this.notesDialog = false
        this.noteEditId = null
        this.editNotes = ''
        this.savingNotes = false
      })
      .catch(() => {
        this.savingNotes = false
        alert('Something went wrong, unfortunately saving notes only works when you have an internet connection.')
      })
    },
    openEditNoteDialog (job) {
      console.log(job)
      this.notesDialog = true
      this.editNotes = job.notes
      this.noteEditId = job.number
    },
    resetTemplateObj () {
      dbPromise().then((db) => {
        let tx = db.transaction('templates')
        let templateStore = tx.objectStore('templates')
        return (templateStore.getAllKeys())
      }).then((keys) => {
        keys.forEach((key) => {
          dbPromise().then((db) => {
            let tx = db.transaction('templates')
            let templateStore = tx.objectStore('templates')
            return (templateStore.get(key))
          }).then((val) => {
            this.templateStore[key] = val
          })
        })
      })
      dbPromise().then((db) => {
        let tx = db.transaction('oldTemplates')
        let templateStore = tx.objectStore('oldTemplates')
        return (templateStore.getAllKeys())
      }).then((keys) => {
        keys.forEach((key) => {
          dbPromise().then((db) => {
            let tx = db.transaction('oldTemplates')
            let templateStore = tx.objectStore('oldTemplates')
            return (templateStore.get(key))
          }).then((val) => {
            this.oldTemplateStore[key] = val
          })
        })
      })
    },
    assignJob () {
      this.assigning = true
      fireStore.collection('Jobs').doc(this.activeJob.number).update({Allocated: this.user.id})
      .then(() => {
        this.activeJob.Allocated = this.user.id
        this.assigning = false
      })
    },
    getJobs () {
      this.loading = true
      this.jobs = []
      console.log('getting jobs')
      firedb.ref('/.info/connected').once('value')
      .then(snap => {
        if (snap.val() === true) {
          console.log('1')
          this.online = true
          this.getRemoteData()
        } else {
          console.log('2')
          this.online = false
          this.getLocalData()
        }
      })
    },
    isCurrentJob (job) {
      if (this.currentJob !== undefined) {
        return this.currentJob.number === job.number
      } else {
        return false
      }
    },
    startJob () {
      fireStore.collection('Jobs').doc(this.activeJob.number).update({jobStarted: moment().format('x'), Allocated: this.user.id})
      dbPromise().then((db) => {
        let tx = db.transaction('currentJob', 'readwrite')
        let currentStore = tx.objectStore('currentJob')

        currentStore.put({
          Customer: this.activeJob.Customer,
          number: this.activeJob.number,
          reg: this.activeJob.vehReg,
          JobNo: this.activeJob.JobNo,
          imei: this.activeJob.imei,
          vehicle: this.activeJob.Vehicle,
          newMethod: this.activeJob.newMethod,
          jobLookupIds: this.activeJob.jobLookupIds,
          startTime: moment().format('x'),
          notes: this.activeJob.notes || '',
          chargeable: false,
          requirements: this.activeJob.requirements,
          network: this.activeJob.network,
          ICCID: this.activeJob.ICCID,
          APN: this.activeJob.APN,
          newReg: this.activeJob.newReg,
          newMake: this.activeJob.newMake,
          newModel: this.activeJob.newModel,
          leaveKit: this.activeJob.leaveKit,
          getKit: this.activeJob.getKit
        }, 0)
        return tx.complete
      }).then(() => {
        let templates = []
        this.activeJob.templates.forEach(element => {
          if (this.templateStore[element] !== undefined && this.activeJob.newMethod) {
            templates.push(this.templateStore[element])
          } else if (this.oldTemplateStore[element] !== undefined && !this.activeJob.newMethod) {
            templates.push(this.oldTemplateStore[element])
          } else {
            console.log('undefined')
            this.snackbar = true
            this.snackbarText = 'A required template is missing from your device. Refreshing.'
            this.refreshTemplates()
            this.refreshOldTemplates()
            return
          }
        })
        if (this.snackbar === false) {
          dbPromise().then((db) => {
            let tx = db.transaction('currentJob', 'readwrite')
            let currentStore = tx.objectStore('currentJob')
            currentStore.put(templates, 1)
            return tx.complete
          }).then(() => {
            this.$router.push('/CurrentJob')
          })
        } else {
          dbPromise().then((db) => {
            let tx = db.transaction('currentJob', 'readwrite')
            let currentStore = tx.objectStore('currentJob')

            currentStore.clear()
            return tx.complete
          })
        }
      })
    },
    continueJob () {
      const activeKey = this.inProgressKeys[this.activeJob.number]
      const activeJob = this.inProgressJobs[activeKey]
      activeJob[0].inProgressKey = activeKey
      activeJob[1].forEach(element => {
        if (this.templateStore[element.id] === undefined) {
          console.log('undefined')
          this.snackbar = true
          this.snackbarText = 'A required template is missing from your device. Refreshing.'
          this.refreshTemplates()
          this.refreshOldTemplates()
          return
        }
      })
      if (this.snackbar === false) {
        dbPromise().then((db) => {
          let tx = db.transaction('currentJob', 'readwrite')
          let currentStore = tx.objectStore('currentJob')
          currentStore.put(activeJob[0], 0)
          currentStore.put(activeJob[1], 1)
          return tx.complete
        }).then(() => {
          this.$router.push('/CurrentJob')
        })
      } else {
        dbPromise().then((db) => {
          let tx = db.transaction('currentJob', 'readwrite')
          let currentStore = tx.objectStore('currentJob')

          currentStore.clear()
          return tx.complete
        })
      }
    },
    activateJob (job) {
      if (job.number === this.currentJob.number) {
        this.$router.push('/CurrentJob')
      } else if (this.inProgressKeys[job.number]) {
        this.activeJob = {
          number: job.number,
          Vehicle: job.Vehicle,
          vehReg: job.vehReg,
          notes: job.notes || '',
          chargeable: false,
          templates: job.templates,
          Customer: job.Customer,
          JobNo: job.JobNo,
          imei: job.imei,
          newMethod: job.newMethod,
          jobLookupIds: job.jobLookupIds || [],
          jobStarted: job.jobStarted,
          requirements: job.requirements,
          network: job.network,
          ICCID: job.ICCID,
          APN: job.APN,
          newReg: job.newReg,
          newMake: job.newMake,
          newModel: job.newModel,
          leaveKit: job.leaveKit,
          getKit: job.getKit
        }
        this.continueAlert = true
      } else if (job.Status !== 2 && this.outboxItems.indexOf(job.number) === -1) {
        let imei = null
        if (job.extras !== undefined) {
          imei = job.extras['[Track Smart] Calamp IMEI'] !== undefined ? job.extras['[Track Smart] Calamp IMEI'] : job.extras['[Trailer Smart Calamp] Calamp IMEI'] !== undefined ? job.extras['[Trailer Smart Calamp] Calamp IMEI'] : job.extras['IMEI'] !== undefined ? job.extras['IMEI'] : null
        }
        if (job.templates.length === 2) {
          for (let j of job.templates) {
            if (this.templateStore[j] && this.templateStore[j].name.toLowerCase().indexOf('trailer') !== -1) {
              job.templates.splice(job.templates.indexOf('preCheck'), 1)
              break
            }
          }
        }
        this.activeJob = {
          number: job.number,
          Vehicle: job.Vehicle,
          vehReg: job.vehReg,
          notes: job.notes || '',
          chargeable: false,
          templates: job.templates,
          Customer: job.Customer,
          JobNo: job.JobNo,
          Allocated: job.Allocated,
          imei: imei,
          newMethod: job.newMethod,
          jobLookupIds: job.jobLookupIds || [],
          jobStarted: job.jobStarted,
          requirements: job.requirements,
          network: job.network,
          ICCID: job.ICCID,
          APN: job.APN,
          newReg: job.newReg,
          newMake: job.newMake,
          newModel: job.newModel,
          leaveKit: job.leaveKit,
          getKit: job.getKit

        }
        this.templateSummary = []
        for (let i = 0; i < this.activeJob.templates.length; i++) {
          if (this.templateStore[this.activeJob.templates[i]] !== undefined) {
            this.templateSummary.push(this.templateStore[this.activeJob.templates[i]].name)
          } else if (this.oldTemplateStore[this.activeJob.templates[i]] !== undefined) {
            this.templateSummary.push(this.oldTemplateStore[this.activeJob.templates[i]].name)
          }
        }
        console.log(this.templateSummary)
        this.startAlert = true
      }
    },
    getRemoteData () {
      let ref = ''
      if (this.listView) {
        let statusValue = this.includeCompleted ? 2 : 0
        if (this.selectCustomer === null || this.selectCustomer === undefined) {
          if (this.selectEngineer === -1) {
            ref = fireStore.collection('Jobs').where('Supplier', '==', this.user.company).where('Allocated', '==', '').where('Status', '<=', statusValue)
          } else if (this.selectEngineer === -2) {
            ref = fireStore.collection('Jobs').where('Supplier', '==', this.user.company).where('Status', '<=', statusValue)
          } else {
            ref = fireStore.collection('Jobs').where('Allocated', '==', this.user.id).where('Status', '<=', statusValue)
          }
        } else {
          if (this.selectEngineer === -1) {
            ref = fireStore.collection('Jobs').where('Supplier', '==', this.user.company).where('Allocated', '==', '').where('Status', '<=', statusValue).where('Customer', '==', this.selectCustomer)
          } else if (this.selectEngineer === -2) {
            ref = fireStore.collection('Jobs').where('Supplier', '==', this.user.company).where('Status', '<=', statusValue).where('Customer', '==', this.selectCustomer)
          } else {
            ref = fireStore.collection('Jobs').where('Allocated', '==', this.user.id).where('Status', '<=', statusValue).where('Customer', '==', this.selectCustomer)
          }
        }
      } else {
        if (this.selectEngineer === -1) {
          ref = fireStore.collection('Jobs').where('Supplier', '==', this.user.company).where('Allocated', '==', '').where('Date', '<=', this.date).where('Date', '>=', this.date)
        } else if (this.selectEngineer === -2) {
          ref = fireStore.collection('Jobs').where('Supplier', '==', this.user.company).where('Date', '<=', this.date).where('Date', '>=', this.date)
        } else {
          ref = fireStore.collection('Jobs').where('Allocated', '==', this.user.id).where('Date', '<=', this.date).where('Date', '>=', this.date)
        }
      }
      ref.get()
      .then(snap => {
        let jobs = []
        if (snap !== null) {
          dbPromise().then((db) => {
            let tx = db.transaction('jobStore', 'readwrite')
            let jobStore = tx.objectStore('jobStore')

            jobStore.clear()
            return tx.complete
          }).then(() => {
            snap.forEach((doc) => {
              let data = doc.data()
              data.number = doc.id
              if (data.Status === 2) {
                jobs.push(data)
              } else {
                jobs.unshift(data)
              }
              dbPromise().then((db) => {
                let tx = db.transaction('jobStore', 'readwrite')
                let jobStore = tx.objectStore('jobStore')

                jobStore.put(data, doc.id)
                return tx.complete
              })
              .catch(error => {
                console.log(error)
              })
            })
            this.jobs = jobs
            console.log(this.jobs)
            console.log(this.templateStore)
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    getLocalData () {
      dbPromise().then((db) => {
        let tx = db.transaction('jobStore')
        let jobStore = tx.objectStore('jobStore')
        return (jobStore.get(this.number))
      }).then((val) => {
        if (val !== undefined) {
          this.jobs.push(val)
        }
        this.loading = false
      })
    },
    tomorrow () {
      this.date = moment(this.date).add('1', 'days').format('YYYY-MM-DD')
    },
    yesterday () {
      this.date = moment(this.date).subtract('1', 'days').format('YYYY-MM-DD')
    },
    vehicleRegFromID (id) {
      const index = this.vehicles.findIndex(vehicle => {
        return vehicle.id === id
      })
      if (index > -1) {
        if (this.vehicles[index]['VehicleReg'] && this.vehicles[index]['VehicleReg'].length > 0) {
          return this.vehicles[index]['VehicleReg']
        } else if (this.vehicles[index]['vehReg'] && this.vehicles[index]['vehReg'].length > 0) {
          return this.vehicles[index]['vehReg']
        } else {
          return this.vehicles[index]['friendlyId']
        }
      } else {
        return ''
      }
    },
    refreshTemplates () {
      fireStore.collection('deviceType').get()
      .then((snap) => {
        dbPromise().then((db) => {
          let tx = db.transaction('templates', 'readwrite')
          let currentStore = tx.objectStore('templates')
          currentStore.clear()
          return tx.complete
        })
        .then(() => {
          snap.forEach((doc) => {
            let data = doc.data()
            data.items.forEach((item) => {
              item.image = ''
              item.note = ''
            })
            dbPromise().then((db) => {
              let tx = db.transaction('templates', 'readwrite')
              let templateStore = tx.objectStore('templates')

              templateStore.put(data, doc.id)
              return tx.complete
            }).then(() => {
              this.snackbar = true
              this.snackbarText = 'Templates Refreshed - Try again'
              this.resetTemplateObj()
            })
          })
        })
      })
      .catch((error) => {
        console.log(error)
      })
    },
    refreshOldTemplates () {
      fireStore.collection('Templates').get()
      .then((snap) => {
        dbPromise().then((db) => {
          let tx = db.transaction('oldTemplates', 'readwrite')
          let currentStore = tx.objectStore('oldTemplates')
          currentStore.clear()
          return tx.complete
        })
        .then(() => {
          snap.forEach((doc) => {
            let data = doc.data()
            data.items.forEach((item) => {
              item.image = ''
              item.note = ''
            })
            dbPromise().then((db) => {
              let tx = db.transaction('oldTemplates', 'readwrite')
              let templateStore = tx.objectStore('oldTemplates')

              templateStore.put(data, doc.id)
              return tx.complete
            }).then(() => {
              this.resetTemplateObj()
            })
          })
        })
      })
      .catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>

<style>
  .v-list__tile {
    height: auto;
  }
</style>


// WEBPACK FOOTER //
// JobList.vue?3eef9726